import { render, staticRenderFns } from "./web-editor.vue?vue&type=template&id=a19b2ea0&scoped=true"
import script from "./web-editor.vue?vue&type=script&lang=js"
export * from "./web-editor.vue?vue&type=script&lang=js"
import style0 from "./web-editor.vue?vue&type=style&index=0&id=a19b2ea0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19b2ea0",
  null
  
)

export default component.exports